import { getApiInstance } from "../../AppService";
import {
  CHILD_VARIANT_INVENTORY_PRODUCTS,
  DELETE_BANNER_DATA,
  INVENTORY_ONDC_FILTER,
  INVENTORY_PRODUCTS_BY_STATUS,
  INVENTORY_VARIANT_SINGLE_SUMMARY,
  ONDC_INVENTORY_FILTER,
  PRODUCTS_BY_BUSINESS,
  SINGLE_INVENTORY_PRODUCTS,
  SINGLE_PRODUCT_ONDC_INVENTORY_FILTER,
  UPDATE_INVENTORY,
  VARIANT_COUNT_BY_STATUS,
  VARIANT_INVENTORY_PRODUCTS,
  VARIANT_OOS_COUNT,
} from "../../constant";
import { getVariantCountAPI } from "../BusinessPreview/BusinessPreviewAPI";

export const updateInventoryData = async (data, businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.post(UPDATE_INVENTORY, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBusinessProductsAPI = async (data) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(
      PRODUCTS_BY_BUSINESS + data?.businessId,
      {
        params: {
          business: true,
          percentageOff: false,
          highToLow: false,
          lowToHigh: false,
          pageSize: data?.pageSize || 500,
          pageNo: data?.pageNo || 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInventoryProductsByStatusAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    const response = await instance.get(INVENTORY_PRODUCTS_BY_STATUS, {
      params: {
        status: data?.status || "all",
        ONDC_enabled: "all",
        pageSize: data?.pageSize || 50,
        page: data?.pageNo || 1,
        search: data?.searchQuery || "",
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInventoryOndcFilterAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    // const response = await instance.get(INVENTORY_ONDC_FILTER, {
    const response = await instance.get(ONDC_INVENTORY_FILTER, {
      params: {
        status: data?.status || "in_stock",
        pageSize: data?.pageSize || 50,
        page: data?.pageNo || 1,
        ondcCode: data?.ondcMainCat || "",
        ondcSubCode: data?.ondcSubCat || "",
      },
    });

    if (response?.data?.details?.length > 0) {
      const array = [...response?.data?.details];
      const masterProductVariantIds = array
        .filter((item) => item?.variantInfo?.masterProductVariantId) // Filter only those with a master property
        .map((item) => item?.variantInfo?.masterProductVariantId) // Map to the master.id property
        .join(", ");

      const countRes = await getVarianCountByStatusAPI(
        data?.businessId,
        masterProductVariantIds,
        data?.status
      );

      array.forEach((item) => {
        // Check if the current item has a master property
        if (item.variantInfo?.masterProductVariantId) {
          // Find a matching item in the second array
          const match = countRes?.details?.find(
            (e) =>
              e.masterProductVariantId ===
              item.variantInfo?.masterProductVariantId
          );

          // If a match is found, add the count to the first array's object
          if (match) {
            item.count = match.count;
          }
        }
      });

      console.log("getInventoryVariantProductsAPI Hit1", array);

      return { details: array };
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getInventorySingleOndcFilterAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    const response = await instance.get(SINGLE_PRODUCT_ONDC_INVENTORY_FILTER, {
      params: {
        status: data?.status || "in_stock",
        pageSize: data?.pageSize || 50,
        page: data?.pageNo || 1,
        ondcCode: data?.ondcMainCat || "",
        ondcSubCode: data?.ondcSubCat || "",
      },
    });
    console.log("SINGLE_PRODUCT_ONDC_INVENTORY_FILTER", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInventorySingleProductsByStatusAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    const response = await instance.get(SINGLE_INVENTORY_PRODUCTS, {
      params: {
        status: data?.status || "in_stock",
        ONDC_enabled: "all",
        pageSize: 50,
        // pageSize: data?.pageSize || 50,
        page: data?.pageNo || 1,
        search: data?.searchQuery || null,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getInventoryVariantProductsAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    const response = await instance.get(VARIANT_INVENTORY_PRODUCTS, {
      params: {
        status: data?.status || "in_stock",
        pageSize: 100,
        // pageSize: data?.pageSize || 100,
        page: 1,
        // page: data?.pageNo || 1,
        search: data?.searchQuery || "",
      },
    });

    if (response?.data?.details?.length > 0) {
      const array = [...response?.data?.details];
      const masterProductVariantIds = array
        .filter((item) => item?.variantInfo?.masterProductVariantId) // Filter only those with a master property
        .map((item) => item?.variantInfo?.masterProductVariantId) // Map to the master.id property
        .join(", ");

      const countRes = await getVarianCountByStatusAPI(
        data?.businessId,
        masterProductVariantIds,
        data?.status
      );

      array.forEach((item) => {
        // Check if the current item has a master property
        if (item.variantInfo?.masterProductVariantId) {
          // Find a matching item in the second array
          const match = countRes?.details?.find(
            (e) =>
              e.masterProductVariantId ===
              item.variantInfo?.masterProductVariantId
          );

          // If a match is found, add the count to the first array's object
          if (match) {
            item.count = match.count;
          }
        }
      });

      console.log("getInventoryVariantProductsAPI Hit1", array);

      return { details: array };
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getInventoryChildVariantProductsAPI = async (data) => {
  try {
    const instance = getApiInstance({
      header: { businessId: data?.businessId },
    });
    const response = await instance.get(CHILD_VARIANT_INVENTORY_PRODUCTS, {
      params: {
        status: data?.status || "active",
        ONDC_enabled: "all",
        pageSize: data?.pageSize || 50,
        page: data?.pageNo || 1,
        masterProductVariantId: data?.masterProductVariantId,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getVarianCountByStatusAPI = async (
  businessId,
  masterProductVariantId,
  status
) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(VARIANT_COUNT_BY_STATUS, {
      params: {
        masterProductVariantId,
        status: status || "in_stock",
        page: 1,
        pageSize: 100,
      },
      headers: { businessId },
    });
    console.log("getMainProductsAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getVariantSingleCountAPI = async (businessId) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(INVENTORY_VARIANT_SINGLE_SUMMARY, {
      params: {
        status: "active",
      },
      headers: { businessId },
    });
    console.log("getVariantSingleCountAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
